import { createAsyncThunk } from "@reduxjs/toolkit";
import { EndPoints } from "../../api/endpoints";
import axiosClient from "../../api/axiosClient";

export const getVouchersAtc = createAsyncThunk(
  "voucherAtc",
  async (_, { rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.get(EndPoints.voucherAtc);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

export const getVouchersPublic = createAsyncThunk(
  "getVouchersPublic",
  async (_, { rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.get(EndPoints.voucherPublic);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

export const getVoucherByRequestId = createAsyncThunk(
  "getVoucherByRequestId",
  async (request_id: string | undefined, { rejectWithValue }): Promise<any> => {
    if (!request_id) return;
    try {
      const response = await axiosClient.get(`vouchers/request/${request_id}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

export const getAtcVoucherByRequestId = createAsyncThunk(
  "getAtcVoucherByRequestId",
  async (values: any, { rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.get(
        `vouchers/atc/${values.atc_id}/request/${values.request_id}`
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

export const cancelVoucher = createAsyncThunk(
  "cancelVoucher",
  async (
    { voucher_id, id }: { voucher_id: string; id: string },
    { dispatch, rejectWithValue }
  ): Promise<any> => {
    try {
      const response = await axiosClient.delete(`vouchers/${id}`);
      dispatch(getVoucherByRequestId(voucher_id));
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

export type FilterQueryParams = {
  from: number;
  to: number;
  atc_id: string;
};

export const filterPublicAtc = createAsyncThunk(
  "filterPublicAtc",
  async (queryParams: FilterQueryParams, { rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.get(
        `${EndPoints.voucherPublic}/filter/?from=${queryParams.from}&to=${queryParams.to}&exam_id=${queryParams.atc_id}`
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

export const filterVoucherAtc = createAsyncThunk(
  "filterVoucherAtc",
  async (queryParams: FilterQueryParams, { rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.get(
        `${EndPoints.voucherAtc}/filter/?from=${queryParams.from}&to=${queryParams.to}&atc_id=${queryParams.atc_id}`
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);
